export default __webpack_public_path__ + "static/media/WOms.810fd50f.png";